// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1kKUR","image":"Header_image__3M_TO","name":"Header_name__2MBDe","info":"Header_info__3_0WB","infoRow":"Header_infoRow__6XuR4"};